const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;
// Below a minute the count is rounded up to steps of this, and never announced under one step: a
// seconds-precise estimate would flicker on every tick.
const SECONDS_STEP = 5;

// Which unit the estimate is announced in — coarser as it grows.
const remainingUnit = (seconds: number): 'second' | 'minute' | 'hour' => {
  if (seconds < SECONDS_PER_MINUTE) {
    return 'second';
  }
  return seconds < SECONDS_PER_HOUR ? 'minute' : 'hour';
};

// The number the user reads, in the unit it is announced in: 90s → 2 (minutes). Callers need it on
// its own to agree the plural of the sentence they wrap the duration in.
export const getRemainingCount = (seconds: number): number => {
  if (seconds < SECONDS_PER_MINUTE) {
    return Math.max(SECONDS_STEP, Math.ceil(seconds / SECONDS_STEP) * SECONDS_STEP);
  }
  if (seconds < SECONDS_PER_HOUR) {
    return Math.ceil(seconds / SECONDS_PER_MINUTE);
  }
  return Math.ceil(seconds / SECONDS_PER_HOUR);
};

// The duration alone ("2 min"), locale-aware and free — the caller wraps it in its own translated
// sentence.
export const formatRemainingDuration = (seconds: number, localeCode: string): string =>
  new Intl.NumberFormat(localeCode, {
    style: 'unit',
    unit: remainingUnit(seconds),
    unitDisplay: 'short',
  }).format(getRemainingCount(seconds));
